import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ExamesPage } from './exames.page';

class ExamesContainer extends Component {

    render() {
        return (
            <ExamesPage examesemaberto={this.props.examesemaberto} altura={this.props.altura}/>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        examesemaberto: state.recebimentoMaterial.examesAbertos
    }
}

export default connect(mapStateToProps)(ExamesContainer);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/exames/exames.container.js